var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.clearedLinkV2)?_c('a',{attrs:{"href":_vm.clearedLinkV2.href,"title":_vm.clearedLinkV2.title}},[(_vm.isEntityImage)?_c('ContentImage',{attrs:{"data":_vm.entity}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }